<script setup>
import Logo from "@/Shared/SVG/Logo";
import FlashMessage from "@/Shared/FlashMessage";
import {computed, onMounted, provide, reactive, ref} from "vue";

const navigation = [
    { name: 'Dashboard', slug:'dashboard', href: '/backoffice/', current: true, external: false },
    { name: 'Blogs', slug:'blogs', href: '/backoffice/blogs', current: false, external: false },
    { name: 'Position Categories', slug:'position-categories', href: '/backoffice/position-categories', current: false, external: false },
    { name: 'Positions', slug:'positions', href: '/backoffice/positions', current: false, external: false },
    { name: 'Candidates', slug:'candidates', href: '/backoffice/candidates', current: false, external: false },
    { name: 'Messages', slug:'messages', href: '/backoffice/messages', current: false, external: false },
    { name: 'Faq', slug:'faqs', href: '/backoffice/faqs', current: false, external: false },
];

let props = defineProps({
    config: {
        type: Object,
        default: {current:false}
    },
    user: Object,
});

let state = reactive({})
state.openNavigation = true
</script>

<template>
    <Head>
        <title>Backoffice</title>
    </Head>
    <div class="bg-white min-h-screen">
        <div class="flex md:w-64 md:flex-col md:fixed md:inset-y-0">
            <div class="flex-1 flex flex-col min-h-0 bg-gray-800">
                <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto" v-show="state.openNavigation">
                    <div class="flex items-center flex-shrink-0 px-4">
                        <Link href="/backoffice">
                            <Logo class="w-32" />
                        </Link>
                    </div>
                    <nav class="mt-5 flex-1 px-2 space-y-1">
                        <a v-for="link in navigation" :href="link.href" :class="(config.current && config.current === link.slug)?'bg-gray-700':'text-gray-300 hover:bg-gray-700'" class="text-white group flex items-center px-2 py-2 text-sm font-medium rounded-md">
                            {{link.name}}
                        </a>
                    </nav>
                </div>
                <div class="flex-shrink-0 flex bg-gray-700 p-4">
                    <div class="flex-shrink-0 w-full group block">
                        <div class="flex items-center">
                            <div>
                                <img class="inline-block h-9 w-9 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="">
                            </div>
                            <div class="ml-3">
                                <p class="text-sm font-medium text-white">{{user.full_name}}</p>
                                <Link href="/logout" method="post">
                                    <p class="text-xs font-medium text-gray-300 group-hover:text-gray-200 mt-2">Logout</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="md:pl-64 flex flex-col flex-1">
            <div class="sticky top-0 z-10 md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3 bg-gray-100">
                <button @click.prevent="state.openNavigation = !state.openNavigation " type="button" class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span class="sr-only">Open sidebar</span>
                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
            </div>
            <main class="flex-1">
                <div class="py-6">
                    <FlashMessage></FlashMessage>
                    <slot />
                </div>
            </main>
        </div>
    </div>
</template>
